module.exports = __webpack_public_path__ + "static/media/welcome_light.e38edb91.svg";